// public/v3/src/lib/qmb-optimizer.js — QMB net-revenue comparison (finding 8).
//
// NY is a lesser-of state with no Medicaid CCM rate, so for a QMB/dual
// patient the 20% coinsurance on care-management codes is collectible from
// no one — the practice nets 80% of every code, CCM and APCM alike. The 0.8
// factor is symmetric, so "which code nets more" reduces to comparing gross
// allowables: the 99490 family at the month's logged CCM minutes vs G0558's
// flat case rate (APCM Level 3: 2+ chronic + QMB, NO minute requirement).
//
// The APCM fallback page only offered a decision when the CCM time target
// was missed — exactly backwards for QMB economics: a met-target month with
// 20-59 logged minutes still grosses less as CCM than G0558 flat.
//
// Rates mirror DEFAULT_RATES (billing-generate.js, NYC-locality display
// table; billing-generate is ESM so Jest can't require it — the drift guard
// below is asserted by the unit test against the same literals). Display /
// decision-support only: the billed allowable resolves via medicareRate.js.
// CJS so Jest and the page share it.

const QMB_NET_FACTOR = 0.8;

// Keep in sync with DEFAULT_RATES in billing-generate.js.
const RATES = {
  '99490': 76.02,
  '99439': 58.16,
  'G0558': 135.10,
};

// Gross for the 99490 family at m logged CCM minutes: base at 20, one 99439
// per additional full 20 minutes, capped at 2 add-ons (ADDON_CONFIG).
function ccmFamilyGross(minutes) {
  const m = Number(minutes) || 0;
  if (m < 20) return 0;
  const addons = Math.min(2, Math.floor((m - 20) / 20));
  return +(RATES['99490'] + addons * RATES['99439']).toFixed(2);
}

// Comparison for a confirmed-QMB month. g0558Wins is strict: on a tie the
// CCM family keeps the month (no code flip for zero gain).
function qmbG0558Comparison(minutes) {
  const ccmGross = ccmFamilyGross(minutes);
  const apcmGross = RATES['G0558'];
  return {
    ccmGross,
    apcmGross,
    ccmNet: +(ccmGross * QMB_NET_FACTOR).toFixed(2),
    apcmNet: +(apcmGross * QMB_NET_FACTOR).toFixed(2),
    g0558Wins: apcmGross > ccmGross,
  };
}

module.exports = {
  QMB_NET_FACTOR,
  RATES,
  ccmFamilyGross,
  qmbG0558Comparison,
};
